import React from 'react'
import EmbedNode from '../EmbedNode'

export default function GoogleDriveNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='drive.google.com' className='' text='Google Drive Folder Link' transformUrl={(url) => url.includes('embeddedfolderview')? url:`https://drive.google.com/embeddedfolderview?id=${url.split('/folders/')[1].split('?')[0]}#grid`} id={id} data={data} selected={selected} {...props} />
    )
}